import { useQuery } from '@tanstack/react-query';
import * as api from '../api/categories';

export const useCategories = (businessUuid) =>
  useQuery({
    queryKey: ['categories', businessUuid],
    queryFn: () => api.getCategories(businessUuid),
    enabled: !!businessUuid,
    staleTime: 5 * 60 * 1000,
  });
